import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';



const ReferenceGrid = () => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [referencesWithPA, setReferencesWithPA] = useState([]); // State for references with Payment Advance


    useEffect(() => {
        // Fetching data from the SLAM system
        fetch('http://localhost:5000/api/references/getSlamReferences')
            .then((response) => response.json())
            .then((data) => {
                const updatedData = data.map((item, index) => ({
                    id: index,
                    ...item,
                }));
                setData(updatedData);
            });

        // Fetching the list of traffic_references with a Payment Advance
        fetch('http://localhost:5000/api/references/getReferencesWithPaymentAdvance')
            .then(response => response.json())
            .then(data => setReferencesWithPA(data));

    }, []);

    // Define the getMuiTheme function to create and return a theme.
    const getMuiTheme = () => createTheme({
        components: {
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: 'darkblue', // Set the background color of the header
                            color: 'white', // Set the text color of the header
                        },
                    },
                },
            },
        },
    });

    const handleEdit = (row) => {
        // Handle the edit action here
        // For now, it just logs the row data to the console
        console.log(row);
    };

    const handleAdd = (row) => {
        if (!referencesWithPA.includes(row.traffic_reference)) {
            navigate('/paymentAdvance', { state: { rowData: row } });
        }
    };

    const StyledDataGrid = styled(DataGrid)(({ }) => ({
        fontFamily: "'Roboto', sans-serif",
        border: '1px solid #E0E0E0',
        '& .MuiDataGrid-row': {
            height: '50px', // Adjusting row height
            '&:nth-of-type(odd)': {
                backgroundColor: '#f5f5f5',
            },
            '&:nth-of-type(even)': {
                backgroundColor: '#e8eaf6',
            },
            '&:hover': {
                backgroundColor: '#e1f5fe',
                cursor: 'pointer',
            }
        },
        '& .MuiDataGrid-cell': {
            borderRight: '1px solid #E0E0E0',
            padding: '0 10px', // Adjust cell padding
            '&:last-child': {
                borderRight: 'none',
            }
        },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#34495e',
            color: 'white',
            fontSize: '1rem', // Reduced font size
            fontWeight: '500', // Adjusted font weight
            padding: '0 10px', // Adjust header padding
            borderBottom: '2px solid #E0E0E0',
            height: '55px', // Adjusting header height
            '&:hover': {
                backgroundColor: '#2c3e50',
            }
        },
        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-overlay': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255,255,255,0.9)',
        }
    }));
    
    
    
    const columns = [
        { field: 'traffic_reference', headerName: 'Traffic Reference', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'entry_point', headerName: 'Entry Point', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'license', headerName: 'License', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'pedimento', headerName: 'Pedimento', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'tipo_pedimento', headerName: 'Tipo Pedimento', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'status_pedimento', headerName: 'Status Pedimento', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'status_modulacion', headerName: 'Status Modulacion', width: 200, headerAlign: 'center', align: 'center' },
        { field: 'number_of_reference_invoices', headerName: 'Number of Reference Invoices', width: 250, headerAlign: 'center', align: 'center' },
        {
            field: 'customer_key',
            headerName: 'Customer Key',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.customer_data?.customer_key || "",
        },
        {
            field: 'customer_name',
            headerName: 'Customer Name',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.customer_data?.customer_name || "",
        },
        {
            field: 'customer_rfc',
            headerName: 'Customer RFC',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.customer_data?.customer_rfc || "",
        },
        {
            field: 'container_number',
            headerName: 'Container Number',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.container_data?.container_number || "",
        },
        {
            field: 'container_type',
            headerName: 'Container Type',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.container_data?.container_type || "",
        },
        {
            field: 'container_size',
            headerName: 'Container Size',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (params) => params.row.container_data?.container_size || "",
        },
        {
            field: 'actions',
            headerName: 'Actions',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            width: 200,
            renderCell: (params) => (
                <div className="flex justify-between">
                    <Button
                        variant="contained"
                        className={`${
                            referencesWithPA.includes(params.row.traffic_reference) ? 'bg-gray-300' : 'bg-red-500'
                        } text-white`}
                        onClick={() => handleAdd(params.row)}
                        disabled={referencesWithPA.includes(params.row.traffic_reference)}
                    >
                        Add PA
                    </Button>
                    <Button
                        variant="contained"
                        className="bg-purple-700 text-white ml-2"
                        onClick={() => handleEdit(params.row)}
                    >
                        Edit PA
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <ThemeProvider theme={getMuiTheme()}>
            <h1 className="text-2xl font-bold text-center mb-5">Reference Monitor</h1>
            <div className="h-[600px] w-[95%] mx-auto">
                <StyledDataGrid
                    rows={data}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row.traffic_reference}
                    components={{
                        Toolbar: GridToolbar,
                    }}
                />
            </div>
        </ThemeProvider>
    );
};
export default ReferenceGrid;
